class NavigableContent {
    containerEl: HTMLElement;
    itemElArray: HTMLElement[];
    arrowElArray: HTMLElement[];
    index = 0;

    constructor(element: HTMLElement) {
        this.containerEl = element;
        this.itemElArray = [].slice.call(this.containerEl.querySelectorAll(".navigable-content__item")) as HTMLElement[];
        this.arrowElArray = [].slice.call(this.containerEl.querySelectorAll(".navigable-content__controls button")) as HTMLElement[];

        for (const arrowEl of this.arrowElArray) {
            arrowEl.addEventListener("click", (e: MouseEvent) => {
                const target = e.currentTarget as HTMLElement;
                this.arrowClickHandler(parseInt(target.dataset.increment));

                console.log("clicked");
            })
        }
    }

    arrowClickHandler(increment: number) {
        const lastItemIndex = this.itemElArray.length - 1;
        this.index += increment;

        if (this.index <= 0) this.index = 0;
        if (this.index > lastItemIndex) this.index = lastItemIndex;

        for (let i = 0; i < this.itemElArray.length; i++) {
            const itemEl = this.itemElArray[i];
            itemEl.setAttribute("aria-selected", (i === this.index).toString());
        }

        this.containerEl.dataset.index = this.index.toString();
        this.containerEl.dataset.max = (this.index === lastItemIndex).toString();
    }

}

const navigableContent = () => {
    const navigableContentElArray = [].slice.call(document.querySelectorAll(".navigable-content")) as HTMLElement[];
    const instanceArray = [];

    for (const navigableContentEl of navigableContentElArray) {
        instanceArray.push(new NavigableContent(navigableContentEl));
    }
}

export default navigableContent;